"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sensors = void 0;
const react_1 = __importDefault(require("react"));
const hooks_1 = require("../../hooks");
const SensorSort_1 = require("./SensorSort");
const SensorPublished_1 = require("./SensorPublished");
const SensorCollection_1 = require("./SensorCollection");
const SensorSearchTerm_1 = require("./SensorSearchTerm");
const SensorInventoryAvailable_1 = require("./SensorInventoryAvailable");
const SensorCustom_1 = require("./SensorCustom");
const Sensors = () => {
    const { options } = (0, hooks_1.useReactifySearchContext)();
    if (options.mode === "search" || options.mode === "instant-search") {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(SensorSort_1.SensorSort, null),
            react_1.default.createElement(SensorPublished_1.SensorPublished, null),
            react_1.default.createElement(SensorSearchTerm_1.SensorSearchTerm, null),
            react_1.default.createElement(SensorInventoryAvailable_1.SensorInventoryAvailable, null),
            react_1.default.createElement(SensorCustom_1.SensorCustom, null)));
    }
    if (options.mode === "collection") {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(SensorSort_1.SensorSort, null),
            react_1.default.createElement(SensorPublished_1.SensorPublished, null),
            react_1.default.createElement(SensorCollection_1.SensorCollection, null),
            react_1.default.createElement(SensorInventoryAvailable_1.SensorInventoryAvailable, null),
            react_1.default.createElement(SensorCustom_1.SensorCustom, null)));
    }
    return null;
};
exports.Sensors = Sensors;
//# sourceMappingURL=Sensors.js.map